import * as React from 'react';

import { Loader2 } from 'lucide-react';
import { MainButton, MainButtonProps } from '../main-button/main-button';

export interface LoadingMainButtonProps extends MainButtonProps {
  loading?: boolean;
}

const LoadingMainButton = React.forwardRef<HTMLButtonElement, LoadingMainButtonProps>(
  ({ loading, children, disabled, contentType, ...props }, ref) => {
    return (
      <MainButton
        ref={ref}
        disabled={loading || disabled}
        contentType={loading ? 'icon' : contentType}
        {...props}
      >
        {loading && <Loader2 className="animate-spin" />}
        {children}
      </MainButton>
    );
  },
);
LoadingMainButton.displayName = 'LoadingMainButton';

export { LoadingMainButton };
